// compare two arrays, return the number of differences
import { toInt } from './type-checks';
export function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length);
    var lengthDiff = Math.abs(array1.length - array2.length);
    var diffs = 0;
    var i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i])
            || (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}
//# sourceMappingURL=compare-arrays.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/chronos/utils/compare-arrays.js
// module id = 515
// module chunks = 10